export const sidebarContent: {
  name: string;
  link: string;
  icon?: string;
  nestedLink: { name: string; link: string }[] | null;
  hasNoGuard?: boolean;
  endpoint?: string;
}[] = [
  {
    name: 'Home',
    icon: 'home',
    link: '',
    nestedLink: null,
    hasNoGuard: true,
  },
  {
    name: 'Dashboard',
    icon: 'dashboard',
    link: 'analytics',
    nestedLink: null,
    hasNoGuard: true,
  },
  {
    name: 'Projects',
    icon: 'projects',
    link: 'projects/all',
    nestedLink: [
      { name: 'Single Phase Projects', link: 'projects/single-phase' },
      { name: 'Multiple Phase Projects', link: 'projects/multiple-phase' },
    ],
    endpoint: 'company/project',
  },
  {
    name: 'Users',
    icon: 'users',
    link: 'users/all',
    nestedLink: [
      { name: 'Active', link: 'users/active' },
      { name: 'Inactive', link: 'users/inactive' },
      { name: 'Pending', link: 'users/pending' },
    ],
    endpoint: 'fetchCompanyTeamMember/{companyId}',
  },
  {
    name: 'Companies',
    icon: 'partner',
    link: 'companies',
    nestedLink: null,
    endpoint: 'company/partnerBuilding/partners',
    hasNoGuard: true,
  },
  {
    name: 'Roles',
    icon: 'roles',
    link: 'roles/all',
    nestedLink: [
      { name: 'Active', link: 'roles/active' },
      { name: 'Inactive', link: 'roles/inactive' },
      { name: 'Pending', link: 'roles/pending' },
    ],
    endpoint: 'role',
  },
  {
    name: 'Form Builder',
    icon: 'forms',
    link: 'form-builder',
    nestedLink: null,
    hasNoGuard: true,
  },
  {
    name: 'Tasks',
    icon: 'tasks',
    link: 'tasks',
    nestedLink: null,
    endpoint: 'company/taskBuilding/task',
    hasNoGuard: true,
  },
  {
    name: 'Settings',
    link: '',
    icon: 'settings',
    nestedLink: null,
    hasNoGuard: true,
  },
  {
    name: 'My Account',
    link: '',
    icon: 'my-account',
    nestedLink: null,
    hasNoGuard: true,
  },
];
